module.exports = __webpack_public_path__ + "img/icn_project.d7b54027.svg";